import { SvgIcon, SvgIconProps } from '@mui/material';

export const PhoneOutgoing = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox='0 0 16 16'>
      <mask
        id='mask0_1413_3592'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='16'
        height='16'>
        <rect width='16' height='16' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_1413_3592)'>
        <path
          d='M13.3 14C11.9111 14 10.5389 13.6972 9.18333 13.0917C7.82778 12.4861 6.59444 11.6278 5.48333 10.5167C4.37222 9.40555 3.51389 8.17222 2.90833 6.81667C2.30278 5.46111 2 4.08889 2 2.7C2 2.5 2.06667 2.33333 2.2 2.2C2.33333 2.06667 2.5 2 2.7 2H5.4C5.55556 2 5.69444 2.05278 5.81667 2.15833C5.93889 2.26389 6.01111 2.38889 6.03333 2.53333L6.46667 4.86667C6.48889 5.04444 6.48333 5.19444 6.45 5.31667C6.41667 5.43889 6.35556 5.54444 6.26667 5.63333L4.65 7.26667C4.87222 7.67778 5.13611 8.075 5.44167 8.45833C5.74722 8.84166 6.08333 9.21111 6.45 9.56666C6.79444 9.91111 7.15556 10.2306 7.53333 10.525C7.91111 10.8194 8.31111 11.0889 8.73333 11.3333L10.3 9.76666C10.4 9.66666 10.5306 9.59166 10.6917 9.54166C10.8528 9.49166 11.0111 9.47778 11.1667 9.5L13.4667 9.96666C13.6222 10.0111 13.75 10.0917 13.85 10.2083C13.95 10.325 14 10.4556 14 10.6V13.3C14 13.5 13.9333 13.6667 13.8 13.8C13.6667 13.9333 13.5 14 13.3 14ZM4.01667 6L5.11667 4.9L4.83333 3.33333H3.35C3.40556 3.78889 3.48333 4.23889 3.58333 4.68333C3.68333 5.12778 3.82778 5.56667 4.01667 6ZM9.98333 11.9667C10.4167 12.1556 10.8583 12.3056 11.3083 12.4167C11.7583 12.5278 12.2111 12.6 12.6667 12.6333V11.1667L11.1 10.85L9.98333 11.9667Z'
          fill='currentColor'
        />
        <path
          d='M14 6.0001L14 2.0001L10 2.0001L10 3.33343L11.7333 3.33343L8.4 6.66677L9.33333 7.6001L12.6667 4.26676L12.6667 6.0001L14 6.0001Z'
          fill='currentColor'
        />
      </g>
    </SvgIcon>
  );
};
